import { useState } from 'react';
import services from 'src/services/Services';

const initialModules = {
    activateRoles: false,
    activateUsers: false,
    activateExist: false,
    activateExport: false,
    activateTokens: false,
    activatePedidos: false,
    activatePrecio: false
};

const moduleMapper = {
    activateRoles: "roles",
    activateUsers: "usuarios",
    activateExist: "existencias",
    activatePedidos: "pedidos",
    activateTokens: "tokens"
};

const useAddRol = (getRoles, handlerOpenAlertAdd) => {
    const [open, setOpen] = useState(false);
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");

    const [modules, setModules] = useState(initialModules);

    const selectedModules = Object.keys(modules)
        .filter(key => modules[key] === true)
        .map(key => moduleMapper[key])
        .filter(Boolean);

    const [alert, setAlert] = useState({
        open: false,
        type: "error",
        message: ""
    });

    /** -----------------------
     *  ABRIR / CERRAR DIALOG
     * ----------------------- */
    const handleOpen = () => setOpen(true);

    const handleClose = () => {
        setOpen(false);
        setName("");
        setDescription("");
        setModules(initialModules);
    };

    /** -----------------------
     *       ALERTAS LOCALES
     * ----------------------- */
    const openAlert = (type, message) => {
        setAlert({ open: true, type, message });
    };

    const closeAlert = () => {
        setAlert({ ...alert, open: false });
    };

    /** -----------------------
     *     ACTUALIZAR MÓDULOS
     * ----------------------- */
    const updateModule = (key, value) => {
        setModules(prev => ({ ...prev, [key]: value }));
    };

    /** -----------------------
     *       GUARDAR ROL
     * ----------------------- */
    const onSave = async () => {
        if (!name.trim()) {
            openAlert("error", "El nombre del rol es obligatorio");
            return;
        }

        try {
            /** 1) Crear rol principal en Keycloak */
            await services.addRole({
                name,
                description
            });

            /** 2) Obtener ID recién creado */
            const r = await services.getRoleJusCreated(name);
            const id = r.data.id;

            /** 3) Obtener fecha actual desde tu API */
            const todayResp = await services.getDate();
            const isoDate = todayResp.data.Fecha.split(" ")[0];

            /** 4) Construir atributos finales */
            const body = {
                id,
                name,
                description,
                composite: false,
                clientRole: true,
                containerId: "2758d422-8dff-4b47-9706-40559e829d47",

                attributes: {
                    fechaCreacion: [isoDate],
                    modulos: selectedModules,
                    exportacion: [modules.activateExport],
                    precio: [modules.activatePrecio]
                }
            };

            /** 5) Actualizar atributos del rol */
            await services.updateAttributeRole(id, body);

            /** 6) ALERTA GLOBAL (desde AdminRoles) */
            if (handlerOpenAlertAdd) handlerOpenAlertAdd();

            /** 7) ALERTA LOCAL */
            openAlert("success", "Rol creado correctamente");

            /** 8) Cerrar y limpiar formulario */
            handleClose();

            /** 9) Refrescar lista en el padre */
            setTimeout(() => getRoles(), 600);

        } catch (error) {
            openAlert("error", "Error al crear el rol");
            console.error("AddRol error:", error);
        }
    };

    return {
        open,
        handleOpen,
        handleClose,
        name,
        setName,
        description,
        setDescription,
        modules,
        updateModule,
        onSave,
        alert,
        closeAlert
    };
};

export default useAddRol;
